import React from 'react';
import { 
  LineChartOutlined,
  QuestionCircleOutlined,
  WarningOutlined
} from '@ant-design/icons';

export const TeamDynamics: React.FC = () => {
  // Hardcoded dashboard metrics representing elements distribution across current ENTERPRISE team members
  const teamElements = {
    wood: { count: 12, label: 'Creative & Growth', status: 'Excellent coverage' },
    fire: { count: 4, label: 'Passion & Leadership', status: 'Needs coverage (Low count)' },
    earth: { count: 18, label: 'Stability & Operations', status: 'Dominant (High operational focus)' },
    metal: { count: 8, label: 'Logic & Engineering', status: 'Good coverage' },
    water: { count: 10, label: 'Strategy & Communication', status: 'Good coverage' }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">
          Team Dynamics Element Map
        </h1>
        <p className="text-slate-500 text-sm">
          Map the elemental balance of your entire department to identify skill gaps and hiring coverage needs.
        </p>
      </div>

      {/* Grid distribution */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {Object.entries(teamElements).map(([el, info]) => {
          const colorClass = 
            el === 'wood' ? 'border-emerald-500 text-emerald-700 bg-emerald-50/50' :
            el === 'fire' ? 'border-red-500 text-red-700 bg-red-50/50' :
            el === 'earth' ? 'border-amber-500 text-amber-700 bg-amber-50/50' :
            el === 'metal' ? 'border-slate-500 text-slate-700 bg-slate-50/50' :
            'border-blue-500 text-blue-700 bg-blue-50/50';

          return (
            <div key={el} className={`p-4 border-2 rounded-lg ${colorClass} space-y-2`}>
              <strong className="text-xs uppercase tracking-wider block font-bold">{el} Element</strong>
              <div className="text-3xl font-black">{info.count}</div>
              <div className="text-xs font-semibold">{info.label}</div>
              <div className="text-[10px] font-bold text-slate-500 pt-1 border-t border-slate-200/50">{info.status}</div>
            </div>
          );
        })}
      </div>

      {/* HR Strategy block */}
      <div className="bg-white border border-slate-200 rounded-lg p-5 shadow-sm space-y-4">
        <h3 className="text-sm font-bold text-slate-950 flex items-center gap-1.5 border-b border-slate-100 pb-2">
          <LineChartOutlined style={{ fontSize: 16, color: '#4f46e5' }} />
          Astrological Hiring Recommendations
        </h3>

        <div className="space-y-3 text-sm text-slate-600">
          <div className="flex gap-2">
            <WarningOutlined style={{ fontSize: 18, color: '#f59e0b' }} className="flex-shrink-0" />
            <p>
              Your team is currently heavily weighted in <strong className="text-slate-800">Earth (Stabilizers & Operations)</strong>. While operations are extremely smooth, you may experience a lack of speed in launching new products or entering aggressive markets due to a shortage of <strong className="text-slate-800">Fire (Leadership & Vision)</strong>.
            </p>
          </div>
          <div className="flex gap-2">
            <QuestionCircleOutlined style={{ fontSize: 18, color: '#6366f1' }} className="flex-shrink-0" />
            <p>
              When evaluating candidates for next job vacancies, prioritize applicants with dominant <strong className="text-slate-800">Fire</strong> or <strong className="text-slate-800">Metal</strong> elements to restore structural balance in the department.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TeamDynamics;
